import css from 'styled-jsx/css';

const styles = css`
  .wholesale-container {
    width: fit-content;
  }

  .static-height {
    min-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .static-height.equal {
    min-height: 56px;
  }

  .static-height.greaterOrEqual {
    min-height: 34px;
  }
`;

export default styles;
